/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_Scope_TitleInputs */

const en_svc_research_scope_title = /** @type {(inputs: Svc_Research_Scope_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What a research agent can take on.`)
};

const lv_svc_research_scope_title = /** @type {(inputs: Svc_Research_Scope_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ko izpētes aģents var pārņemt.`)
};

/**
* | output |
* | --- |
* | "What a research agent can take on." |
*
* @param {Svc_Research_Scope_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_scope_title = /** @type {((inputs?: Svc_Research_Scope_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_Scope_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_scope_title(inputs)
	return en_svc_research_scope_title(inputs)
});